export function TermsContent() {
  return (
    <div className="legal-document text-sm text-brand-text leading-relaxed space-y-6">

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          1. Aceitação dos Termos
        </h2>
        <p className="mb-3">
          Bem-vindo ao RegenerAI. Estes Termos de Uso regulam o acesso e a utilização da
          plataforma RegenerAI, solução tecnológica baseada em inteligência artificial
          desenvolvida para apoiar agricultores, técnicos e pesquisadores na transição para
          práticas agrícolas regenerativas.
        </p>
        <p className="mb-3">
          Ao acessar, cadastrar-se ou utilizar qualquer serviço oferecido pelo RegenerAI, você
          declara ter lido, compreendido e aceitado integralmente estes Termos de Uso. Caso
          não concorde com qualquer disposição aqui contida, não utilize a plataforma.
        </p>
        <p>
          <strong>Menores de 18 anos:</strong> O RegenerAI não se destina a menores de 18 anos.
          Caso você seja menor de idade, somente poderá utilizar a plataforma com o consentimento
          expresso de seus pais ou responsáveis legais.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          2. Descrição do Serviço
        </h2>
        <p className="mb-3">O RegenerAI é uma plataforma digital que oferece:</p>
        <ul className="list-disc list-outside ml-5 space-y-2 mb-3">
          <li>
            <strong>Assistente de IA:</strong> respostas personalizadas sobre agricultura
            regenerativa baseadas em dados científicos e casos reais;
          </li>
          <li>
            <strong>Marketplace:</strong> catálogo de produtos e parceiros especializados em
            agricultura regenerativa;
          </li>
          <li>
            <strong>Conteúdo educativo:</strong> artigos, guias e melhores práticas para a
            transição regenerativa;
          </li>
          <li>
            <strong>Comunidade:</strong> espaço de conexão entre produtores, técnicos e
            pesquisadores.
          </li>
        </ul>
        <p>
          As respostas geradas pela IA são baseadas em conhecimento científico validado e
          melhores práticas reconhecidas. No entanto, elas não substituem consultoria técnica
          especializada nem análise local específica. O RegenerAI é uma ferramenta de apoio
          educacional; decisões agrícolas devem considerar condições locais e, quando necessário,
          orientação de profissionais qualificados.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          3. Cadastro e Responsabilidades do Usuário
        </h2>
        <h3 className="font-semibold mb-2">3.1. Informações Cadastrais</h3>
        <p className="mb-4">
          Para utilizar o RegenerAI, você deverá fornecer informações verdadeiras, exatas e
          completas, incluindo nome, e-mail, CPF e demais dados solicitados no formulário de
          cadastro. Você é responsável por manter suas informações atualizadas.
        </p>
        <h3 className="font-semibold mb-2">3.2. Segurança da Conta</h3>
        <p className="mb-4">
          Você é o único responsável pela confidencialidade de sua senha e pela segurança de sua
          conta. O RegenerAI nunca solicitará sua senha por e-mail, telefone ou qualquer outro
          meio. Em caso de suspeita de uso não autorizado, contate-nos imediatamente.
        </p>
        <h3 className="font-semibold mb-2">3.3. Conduta do Usuário</h3>
        <p className="mb-3">Ao utilizar o RegenerAI, você compromete-se a:</p>
        <ul className="list-disc list-outside ml-5 space-y-2">
          <li>fornecer informações verídicas e atualizadas;</li>
          <li>utilizar a plataforma para fins legítimos e educacionais;</li>
          <li>não compartilhar conteúdo ofensivo, discriminatório ou ilegal;</li>
          <li>respeitar outros usuários e profissionais da comunidade;</li>
          <li>não tentar violar a segurança ou a integridade da plataforma;</li>
          <li>não utilizar as respostas da IA para fins comerciais diretos sem autorização.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          4. Propriedade Intelectual
        </h2>
        <h3 className="font-semibold mb-2">4.1. Conteúdo do Usuário</h3>
        <p className="mb-3">
          Você mantém todos os direitos sobre as informações, perguntas e dados que fornecer ao
          RegenerAI. Ao utilizar a plataforma, você concede ao RegenerAI uma licença não
          exclusiva, gratuita e mundial para usar, armazenar e processar suas informações com o
          objetivo de personalizar as respostas da IA, melhorar a qualidade do serviço e gerar
          estatísticas anônimas para fins de melhoria contínua.
        </p>
        <h3 className="font-semibold mb-2">4.2. Respostas da IA</h3>
        <p className="mb-3">
          As respostas geradas pela inteligência artificial do RegenerAI são disponibilizadas para
          seu uso pessoal e educacional. Você pode compartilhá-las e citá-las, desde que mencione
          a fonte ("Resposta gerada pelo RegenerAI") e não as utilize para fins comerciais diretos
          ou revenda.
        </p>
        <h3 className="font-semibold mb-2">4.3. Plataforma RegenerAI</h3>
        <p>
          O RegenerAI, incluindo design, código, algoritmos, interface e funcionalidades, é
          protegido por direitos autorais e outras legislações de propriedade intelectual. É
          proibida a cópia, modificação, distribuição ou criação de trabalhos derivados sem
          autorização expressa.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          5. Privacidade e Proteção de Dados
        </h2>
        <p className="mb-3">
          A privacidade dos seus dados é fundamental para nós. O tratamento de dados pessoais
          pelo RegenerAI está em conformidade com a Lei Geral de Proteção de Dados
          (LGPD — Lei nº 13.709/2018).
        </p>
        <ul className="list-disc list-outside ml-5 space-y-2 mb-3">
          <li>
            <strong>Consentimento:</strong> seus dados são coletados apenas com seu consentimento
            explícito;
          </li>
          <li>
            <strong>Finalidade:</strong> uso exclusivo para personalizar e melhorar os nossos
            serviços;
          </li>
          <li>
            <strong>Segurança:</strong> criptografia e controles rigorosos de acesso;
          </li>
          <li>
            <strong>Direitos:</strong> acesso, correção, exclusão e portabilidade dos seus dados;
          </li>
          <li>
            <strong>Anonimização:</strong> dados usados para melhoria são sempre anonimizados.
          </li>
        </ul>
        <p>
          Para detalhes completos sobre o tratamento de dados, consulte nossa Política de
          Privacidade disponível em regenerai.ag/privacy.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          6. Limitação de Responsabilidade
        </h2>
        <h3 className="font-semibold mb-2">6.1. Natureza do Serviço</h3>
        <p className="mb-4">
          O RegenerAI é uma plataforma educacional e de apoio, não constituindo consultoria
          técnica agronômica, veterinária ou ambiental. As respostas da IA são baseadas em
          conhecimento geral e devem ser adaptadas às suas condições locais específicas.
        </p>
        <h3 className="font-semibold mb-2">6.2. Exclusão de Garantias</h3>
        <p className="mb-3">O RegenerAI não garante que:</p>
        <ul className="list-disc list-outside ml-5 space-y-2 mb-4">
          <li>as respostas da IA sejam 100% precisas ou adequadas ao seu caso específico;</li>
          <li>a plataforma esteja disponível ininterruptamente;</li>
          <li>os resultados agrícolas sejam positivos ou garantidos;</li>
          <li>as informações estejam atualizadas em tempo real.</li>
        </ul>
        <h3 className="font-semibold mb-2">6.3. Limitação de Danos</h3>
        <p>
          Em nenhuma hipótese o RegenerAI será responsável por danos diretos, indiretos,
          incidentais, consequenciais ou punitivos decorrentes do uso ou da incapacidade de usar
          a plataforma, incluindo perdas agrícolas, financeiras ou de qualquer outra natureza.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          7. Disponibilidade do Serviço
        </h2>
        <p className="mb-3">
          O RegenerAI se esforça para manter a plataforma disponível 24 horas por dia, 7 dias
          por semana, mas não garante disponibilidade ininterrupta. Podemos realizar manutenções
          programadas, atualizações ou interrupções por razões técnicas, de segurança ou
          operacionais.
        </p>
        <p className="mb-3">
          Reservamo-nos o direito de suspender ou encerrar seu acesso ao RegenerAI nas seguintes
          situações: violação destes Termos de Uso; uso indevido ou fraudulento da plataforma;
          atividades que comprometam a segurança do serviço; requisição de autoridades
          competentes; ou inatividade por período superior a 24 meses.
        </p>
        <p>
          Em caso de suspensão, notificaremos você com antecedência sempre que possível, exceto
          em situações urgentes de segurança.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          8. Atualizações e Modificações
        </h2>
        <p className="mb-3">
          O RegenerAI está em constante evolução. Podemos atualizar, modificar ou aprimorar
          recursos, funcionalidades e estes Termos de Uso periodicamente.
        </p>
        <p className="mb-3">
          Mudanças significativas serão comunicadas com 30 dias de antecedência por e-mail ao
          endereço cadastrado, por aviso na plataforma ao fazer login e por publicação em nosso
          site.
        </p>
        <p>
          O uso continuado da plataforma após as mudanças constitui aceitação dos novos termos.
          Caso discorde das alterações, você pode encerrar sua conta a qualquer momento por meio
          das Configurações.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          9. Propriedade Intelectual de Terceiros
        </h2>
        <p className="mb-3">
          O RegenerAI pode incorporar conteúdo, tecnologias ou funcionalidades de terceiros,
          incluindo modelos de linguagem e algoritmos de IA, bibliotecas e frameworks de código
          aberto, conteúdo científico e técnico de parceiros e integrações com serviços externos.
        </p>
        <p>
          O uso desses recursos está sujeito aos termos e condições de seus respectivos
          proprietários. Não somos responsáveis pela disponibilidade ou funcionamento de serviços
          de terceiros.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          10. Lei Aplicável e Jurisdição
        </h2>
        <p className="mb-3">
          Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Qualquer
          disputa decorrente destes termos será resolvida no Foro Central da Comarca de
          São Paulo/SP, exceto quando houver competência de Justiça Federal.
        </p>
        <p>
          Para usuários internacionais, estes termos também respeitarão as legislações locais
          aplicáveis, especialmente em matéria de proteção de dados.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          11. Contato e Suporte
        </h2>
        <p className="mb-3">
          Para dúvidas, sugestões ou problemas relacionados a estes Termos de Uso, entre em
          contato conosco pelos canais abaixo:
        </p>
        <ul className="list-none space-y-2">
          <li><strong>E-mail geral:</strong> contato@regenerai.ag</li>
          <li><strong>Encarregado de Proteção de Dados (DPO):</strong> dpo@regenerai.ag</li>
          <li><strong>Última atualização:</strong> 23 de março de 2026 — Versão 1.0</li>
        </ul>
      </section>

    </div>
  )
}
